import {observer} from 'mobx-react-lite'
import clubStore from '../../../storage/ClubStore'
import appStore from '../../../storage/AppStore'
import {useEffect} from 'react'
import MemberDebts from './MemberDebts'

const MemberHome = () => {
  useEffect(() => {
    if (clubStore.club.id && clubStore.is_member) {
      clubStore.child.getChild()
    }
  }, [clubStore.club.id])
  if (!clubStore.club?.is_member) return null;
  return (
    <div className={"mb-5"}>
      <h4 className={"mb-2"}>{appStore.tr.welcome}, {clubStore.child.child.title}!</h4>
      <MemberDebts />
    </div>
  );
}

export default observer(MemberHome)